import { createSelector } from 'reselect';

const getLastCommandStatus = ({ powertrainTools }) => {
    return powertrainTools?.lastCommandStatus;
};

const getLastCommandStatusLoadingStatus = ({ powertrainTools }) => {
    return powertrainTools?.lastCommandStatus?.loadingStatus;
};

export const getModel = createSelector(
    [
        getLastCommandStatus,
        getLastCommandStatusLoadingStatus
    ],
    (
        lastCommandStatus,
        lastCommandStatusLoadingStatus
    ) => {
        return {
            lastCommandStatus,
            lastCommandStatusLoadingStatus
        };
    }
);
